import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-bon-de-livraison',
  templateUrl: './document-bon-de-livraison.component.html',
  styleUrls: ['./document-bon-de-livraison.component.scss']
})
export class DocumentBonDeLivraisonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
